var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_21559)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.25C5.66848 6.25 5.35054 6.3817 5.11612 6.61612C4.8817 6.85054 4.75 7.16848 4.75 7.5V19.5C4.75 19.8315 4.8817 20.1495 5.11612 20.3839C5.35054 20.6183 5.66848 20.75 6 20.75H18C18.3315 20.75 18.6495 20.6183 18.8839 20.3839C19.1183 20.1495 19.25 19.8315 19.25 19.5V7.5C19.25 7.16848 19.1183 6.85054 18.8839 6.61612C18.6495 6.3817 18.3315 6.25 18 6.25H6ZM4.05546 5.55546C4.57118 5.03973 5.27065 4.75 6 4.75H18C18.7293 4.75 19.4288 5.03973 19.9445 5.55546C20.4603 6.07118 20.75 6.77065 20.75 7.5V19.5C20.75 20.2293 20.4603 20.9288 19.9445 21.4445C19.4288 21.9603 18.7293 22.25 18 22.25H6C5.27065 22.25 4.57118 21.9603 4.05546 21.4445C3.53973 20.9288 3.25 20.2293 3.25 19.5V7.5C3.25 6.77065 3.53973 6.07118 4.05546 5.55546Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.75C16.4142 2.75 16.75 3.08579 16.75 3.5V7.5C16.75 7.91421 16.4142 8.25 16 8.25C15.5858 8.25 15.25 7.91421 15.25 7.5V3.5C15.25 3.08579 15.5858 2.75 16 2.75Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.75C8.41421 2.75 8.75 3.08579 8.75 3.5V7.5C8.75 7.91421 8.41421 8.25 8 8.25C7.58579 8.25 7.25 7.91421 7.25 7.5V3.5C7.25 3.08579 7.58579 2.75 8 2.75Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 11.5C3.25 11.0858 3.58579 10.75 4 10.75H20C20.4142 10.75 20.75 11.0858 20.75 11.5C20.75 11.9142 20.4142 12.25 20 12.25H4C3.58579 12.25 3.25 11.9142 3.25 11.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 14.5C6.25 14.0858 6.58579 13.75 7 13.75H7.013C7.42721 13.75 7.763 14.0858 7.763 14.5C7.763 14.9142 7.42721 15.25 7.013 15.25H7C6.58579 15.25 6.25 14.9142 6.25 14.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26001 14.5C9.26001 14.0858 9.5958 13.75 10.01 13.75H10.015C10.4292 13.75 10.765 14.0858 10.765 14.5C10.765 14.9142 10.4292 15.25 10.015 15.25H10.01C9.5958 15.25 9.26001 14.9142 9.26001 14.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.26 14.5C12.26 14.0858 12.5958 13.75 13.01 13.75H13.015C13.4292 13.75 13.765 14.0858 13.765 14.5C13.765 14.9142 13.4292 15.25 13.015 15.25H13.01C12.5958 15.25 12.26 14.9142 12.26 14.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.265 14.5C15.265 14.0858 15.6008 13.75 16.015 13.75H16.02C16.4342 13.75 16.77 14.0858 16.77 14.5C16.77 14.9142 16.4342 15.25 16.02 15.25H16.015C15.6008 15.25 15.265 14.9142 15.265 14.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.265 17.5C12.265 17.0858 12.6008 16.75 13.015 16.75H13.02C13.4342 16.75 13.77 17.0858 13.77 17.5C13.77 17.9142 13.4342 18.25 13.02 18.25H13.015C12.6008 18.25 12.265 17.9142 12.265 17.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26001 17.5C6.26001 17.0858 6.5958 16.75 7.01001 16.75H7.01501C7.42922 16.75 7.76501 17.0858 7.76501 17.5C7.76501 17.9142 7.42922 18.25 7.01501 18.25H7.01001C6.5958 18.25 6.26001 17.9142 6.26001 17.5Z",
    fill: "#0069AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26001 17.5C9.26001 17.0858 9.5958 16.75 10.01 16.75H10.015C10.4292 16.75 10.765 17.0858 10.765 17.5C10.765 17.9142 10.4292 18.25 10.015 18.25H10.01C9.5958 18.25 9.26001 17.9142 9.26001 17.5Z",
    fill: "#0069AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_21559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.d7061432a8bb96b426d4ec3f74a6546c.svg";
export { ForwardRef as ReactComponent };